import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

export function Auth() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [mode, setMode] = useState<'login' | 'signup' | 'reset'>('login');
  const [message, setMessage] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      if (mode === 'signup') {
        const { error } = await supabase.auth.signUp({
          email,
          password,
          options: {
            emailRedirectTo: window.location.origin,
          }
        });
        
        if (error) throw error;
        
        setMessage('Konto oprettet! Du kan nu logge ind.');
        setMode('login');
      } else if (mode === 'reset') {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: window.location.origin,
        });

        if (error) throw error;
        
        setMessage('Hvis en konto findes med denne email, vil du modtage en email med instruktioner til at nulstille din adgangskode.');
        setMode('login');
      } else {
        const { error } = await supabase.auth.signInWithPassword({
          email,
          password,
        });

        if (error) throw error;
      }
    } catch (error) {
      if (error instanceof Error) {
        setError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">PipelinePro</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          {mode !== 'reset' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={mode !== 'reset'}
                minLength={6}
              />
            </div>
          )}
          {error && (
            <div className="text-red-600 text-sm p-2 bg-red-50 rounded">{error}</div>
          )}
          {message && (
            <div className="text-green-600 text-sm p-2 bg-green-50 rounded">{message}</div>
          )}
          <div className="flex flex-col gap-4">
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 disabled:opacity-50"
            >
              {loading 
                ? (mode === 'login' ? 'Logger ind...' : mode === 'reset' ? 'Sender...' : 'Opretter konto...') 
                : (mode === 'login' ? 'Log ind' : mode === 'reset' ? 'Nulstil adgangskode' : 'Opret konto')}
            </button>
            <div className="flex flex-col gap-2 text-center">
              {mode === 'login' && (
                <button
                  type="button"
                  onClick={() => {
                    setMode('reset');
                    setError(null);
                    setMessage(null);
                  }}
                  className="text-blue-600 hover:text-blue-800 text-sm"
                >
                  Glemt din adgangskode?
                </button>
              )}
              <button
                type="button"
                onClick={() => {
                  setMode(mode === 'login' ? 'signup' : 'login');
                  setError(null);
                  setMessage(null);
                }}
                className="text-blue-600 hover:text-blue-800 text-sm"
              >
                {mode === 'login' 
                  ? 'Har du ikke en konto? Opret en her' 
                  : 'Har du allerede en konto? Log ind her'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}